import React, { useEffect, useState } from 'react'
import AgencyInfo from './components/AgencyInfo/index.js'
import AgencyMembers from './components/AgencyMembers'
import AgencyAvailability from './components/AgencyAvailability'
import { Card } from '@arnsbogroup/react-voicearchive'
import Tabs from 'components/TabsRoutes'
import { Full as Loading } from 'components/Loading'
import { useHistory } from 'react-router-dom'

const AgenciesPage = ({ agencyId }) => {
  const history = useHistory()
  const [agency, setAgency] = useState(null)
  const [loading, setLoading] = useState(false)

  if (!agencyId) {
    return null
  }

  useEffect(() => {
    fetchAgency(agencyId)
  }, [agencyId])

  const onChange = (newStateAgency) => {
    const diff = Object.keys(newStateAgency).reduce((diff, key) => {
      if (agency[key] === newStateAgency[key]) return diff
      return { ...diff, [key]: newStateAgency[key] }
    }, {})

    if (Object.keys(diff).length === 0 && diff.constructor === Object) {
      return
    }
    setLoading(true)
    let prevState = agency;

    fetch(`/rest/v2/agency/${agencyId}`, {
      credentials: 'same-origin',
      method: 'PUT',
      body: JSON.stringify(diff),
    })
    .then(response => response.json())
    .then((response) => {
      setLoading(false)
      if (response.success) {
        toastr.success('Agency updated')
        setAgency(response.data)
      } else {
        toastr.error(response.errors)
      }
    })
    .catch((error) => {
      toastr.error(error)
      setAgency(prevState)
    })
  }

  const fetchAgency = (agencyId) =>{
    setLoading(true)
    fetch(`/rest/v2/agency/${agencyId}?includeRelations=1`)
    .then((response) => response.json())
    .then(({data}) => {
      setLoading(false)
      setAgency(data)
    })
    .catch((error) => toastr.error(error))
  }

  return (
    <div className="w-full h-full">
      { loading ? (
          <Loading />
        ) : (
          <div className="flex">
            <div className="bg-gray w-full">
              <div className="bg-gray-50 p-4">
                <Card className="bg-white">
                  <AgencyInfo agency={agency} onChange={onChange} />
                </Card>
              </div>
              <div>
                  <Tabs
                    className="bg-white"
                    childrenClassName="bg-white"
                    tabsClassName="px-4"
                    tabs={[
                      {
                          message: 'Members',
                          to: `/agencies/${agencyId}/members`,
                          route: {
                            path: '/agencies/:agencyId/members',
                            exact: true,
                            render: () => (
                              <AgencyMembers onChange={onChange} agency={agency} refetch={fetchAgency} />
                            ),
                          }
                      },
                      {
                          message: 'Availability',
                          to: `/agencies/${agencyId}/availability`,
                          route: {
                          path: '/agencies/:agencyId/availability',
                          exact: true,
                          render: () => (
                            <AgencyAvailability onChange={onChange} agency={agency} />
                          ),
                          }
                      },
                  ]}/>
              </div>
            </div>
          </div>
        )}
    </div>
    
  )
}

export default AgenciesPage
